"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MP_SHOP_ENV_URL = void 0;
exports.MP_SHOP_ENV_URL = {
    dqs: 'https://multiproduct.integration.booking.com',
    prod: 'https://multiproduct.booking.com',
};
